import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  editRepresentativeSettingFailed,
  editRepresentativeSettingSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* editRepresentative(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/v1/attorney-powers/${action.payload.id}`;
    const response = yield makeRequest(url, action.payload, action, 'PUT', true);
    if (response.status === OK) {
      yield put(editRepresentativeSettingSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(editRepresentativeSettingFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editRepresentativeSettingFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
